angular.module('impactx.formutil').directive('ixSubmitOnEnter', function () {
    return {
        restrict: 'A',
        require: ['form'],
        link: function (scope, element, attrs) {
            if (!scope.$eval(attrs.ixSubmitOnEnter)) {
                var submitInput = '<input type="submit" ' +
                    'style="position: absolute; left: -9999px; width: 1px; height: 1px;" ' +
                    'tabindex="-1" />';
                element.append(submitInput);
            }
        }
    }
});